export interface AIRunHandle {
  id: number;
  controller: AbortController;
}

export class AIRunLifecycle {
  private sequence = 0;
  private activeRun: AIRunHandle | null = null;
  private canvasRevision = 0;

  startRun(): AIRunHandle {
    this.activeRun?.controller.abort();
    const run = { id: ++this.sequence, controller: new AbortController() };
    this.activeRun = run;
    return run;
  }

  cancelRun(): void {
    this.activeRun?.controller.abort();
    this.activeRun = null;
    this.sequence++;
  }

  isCurrentRun(id: number): boolean {
    return this.activeRun?.id === id && !this.activeRun.controller.signal.aborted;
  }

  finishRun(id: number): boolean {
    if (!this.isCurrentRun(id)) return false;
    this.activeRun = null;
    return true;
  }

  markCanvasChanged(): void {
    this.canvasRevision++;
  }

  getCanvasRevision(): number {
    return this.canvasRevision;
  }

  hasCanvasChanged(revision: number): boolean {
    return this.canvasRevision !== revision;
  }
}
